import * as z from "zod";

const validationSchema = z.object({
  firstname: z.string().min(1, { message: "validation:firstNameRequired" }),
  lastname: z.string().min(1, { message: "validation:lastNameRequired" }),
  email: z.string().min(1, { message: "validation:emailRequired" }),
  // phone: z.string().optional(),
  role: z.enum(["ADMIN", "USER", "VIEWER"], {
    message: "validation:roleTypeRequired",
  }),
  // languageIsoName: z.string().min(1, { message: "validation:languageRequired" }),
  //companyId: z.number(),
});

export const InviteUserValidationSchema = validationSchema;
export type InviteUserFormInput = z.infer<typeof InviteUserValidationSchema>;
